import './Divider.css';

export default function Divider() {
    return (
        <div className='inner-divider'></div>
    )
}